module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAgCAYAAAC7FpAiAAABKUlEQVRYR2NkgIL7MTHrvl+/7vjt7FkBmBgxtNr+/Qy8Dg7EKMWq5vOBAwy3HB1J0s9lbPyBU1Nzv+KSJUEgjYwg4oat7bMvhw9LkmQSVPFAeALmTh5b2+cahw9LMT5ISprzZt68ZHI8ANIzkJ4A2S+SlDSX8aqR0fvv586RlISQPTzQnuA0Mvow5D3BzM//f8h7Apyxh3pyGvUELHMPdMYejYnRmECqaMhpdqBXzKOl02Bodoxm7NGMPZqxMTsNo6XTaOkETRWjlR00IEbzxGieGM0TqHXFaJ4YDHmCmY9v6A/ZgAfPhsUwJihJXNXXf/394kURcsZjB3K0AxQL2ufOCYJHxUHgtp/fjh/Xr1v/vH2bhxTPDIQn2FVVv3Boah5V3bTJA+RWADf2dkZxy5l3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c149.png
// module id = NZUi
// module chunks = 18